
import { oz } from '@weft/utils';
import { TierUsageDataSchema } from '../tier-usage-data';

export const CommitmentTierUsageDataSchema = TierUsageDataSchema.extend({
  billableUnits: oz.number().nonnegative(),
  ytdUnits: oz.number().nonnegative(),
}).openapi('CommitmentTierUsageData');

export type CommitmentTierUsageData = oz.infer<typeof CommitmentTierUsageDataSchema>;